import * as React from 'react';
import { G, Path } from 'react-native-svg';

function Pride() {
  return (
    <G fill="none" strokeLinecap="round" strokeMiterlimit={10}>
      <G strokeWidth={2}>
        <Path d="M29.69 95.48c4.23-1 8.73-2.08 12.86-.69" stroke="#e31b1b" />
        <Path d="M29.15 96.71c4.22-1 9-2.09 13.16-.7" stroke="#e78714" />
        <Path d="M29.29 98.24c4.23-1 9.1-2.07 13.23-.68" stroke="#e2de25" />
        <Path d="M29.36 99.76c4.23-1.05 8.73-2.09 12.86-.7" stroke="#0d9e39" />
        <Path d="M29.61 101c4.23-1 8.73-2.08 12.86-.69" stroke="#2a3c8f" />
        <Path d="M29.7 102.27c4.23-1 8.73-2.09 12.86-.7" stroke="#51358a" />
      </G>
      <Path
        d="M28.72 102.11c0 .39.07.84.41 1a1.15 1.15 0 00.91 0 26.94 26.94 0 0112.11-.58 1.35 1.35 0 001.05-.1 1.29 1.29 0 00.32-1v-5.79a3 3 0 00-.21-1.37c-.45-.91-1.62-1.15-2.64-1.23a33.19 33.19 0 00-10.91 1.29c-2.49.76-1.12 5.67-1.04 7.78z"
        stroke="#09090a"
        strokeWidth={0.25}
      />
      <G>
        <G strokeWidth={2}>
          <Path d="M108.62 103.86c-3.82-2.08-7.92-4.22-12.26-3.92" stroke="#e31b1b" />
          <Path d="M108.84 105.19c-3.83-2.08-8.21-4.31-12.56-4" stroke="#e78714" />
          <Path d="M108.31 106.63c-3.82-2.08-8.28-4.3-12.62-4" stroke="#e2de25" />
          <Path d="M107.86 108.08c-3.83-2.08-7.92-4.22-12.27-3.92" stroke="#0d9e39" />
          <Path d="M107.31 109.21c-3.83-2.08-7.93-4.22-12.27-3.91" stroke="#2a3c8f" />
          <Path d="M106.9 110.42c-3.83-2.08-7.93-4.22-12.27-3.91" stroke="#51358a" />
        </G>
        <Path
          d="M107.88 110.52c-.11.37-.28.79-.65.89a1.14 1.14 0 01-.87-.24 27 27 0 00-11.57-3.63 1.33 1.33 0 01-1-.36 1.28 1.28 0 010-1.1l1.46-5.56a3 3 0 01.55-1.26c.66-.78 1.86-.71 2.86-.53a33.35 33.35 0 0110.23 4c2.17 1.36-.39 5.79-1.01 7.79z"
          stroke="#09090a"
          strokeWidth={0.25}
        />
      </G>
    </G>
  );
}

export default Pride;
